import { nanoid } from 'nanoid'
import { KIBSI_REQUEST_ID_HEADER, RequestInterceptor } from '@kibsi/ks-client-sdk'
import log from 'logging/logger'
import { KibsiAuthConfigProvider } from './kibsi.auth.config'

export function requestHandler(auth: KibsiAuthConfigProvider): RequestInterceptor {
    const onFulfilled: RequestInterceptor[0] = async (config) => {
        log.debug('onRequest', config.url)

        const authorization = await auth.getAuthorization()

        if (authorization) {
            config.headers.set('Authorization', authorization)
        }

        config.headers.set(KIBSI_REQUEST_ID_HEADER, nanoid())
        config.timeout = 29000

        return config
    }

    return [onFulfilled]
}
